import { VisiteBody } from "./../domaine/visiteModel";
import axios, { AxiosError, AxiosResponse } from "axios";
import { readToken } from "../services/localStorage.Service";
import { ProjectModel } from "../domaine/projectModel";

const apiUrl = process.env.REACT_APP_API_URL;

export const axiosInstance = axios.create({
  baseURL: apiUrl,
});

axiosInstance.interceptors.request.use((config: any) => {
  config.headers = {
    ...config.headers,
    Authorization: `Bearer ${readToken()}`,
  };
  return config;
});

axiosInstance.interceptors.response.use(
  (response) => response,
  (error: AxiosError) => {
    if (error.response) {
      // The request was made and the server responded with a status code
      // that falls out of the range of 2xx
      console.error(
        "HTTP error response:",
        error.response.data || "No response data available"
      );
      return Promise.reject(error.response.data);
    } else if (error.request) {
      // The request was made but no response was received
      console.error("HTTP no response:", error.request);
      return Promise.reject({
        message: "No response received from the server",
      });
    } else {
      // Something happened in setting up the request that triggered an Error
      console.error("HTTP request setup error:", error.message);
      return Promise.reject({ message: "Error setting up the request" });
    }
  }
);
export const addVisiteApi = async (
  newVisite: any,
  apiUrl: string
): Promise<any> => {
  try {
    const response: AxiosResponse<any> = await axiosInstance.post<any>(
      apiUrl,
      newVisite
    );
    return response.data.data.id;
  } catch (error: any) {
    console.error("Add visite failed", error);
    throw error.response?.data || "Add visite failed";
  }
};

export const fetchVisitesByTrancheApi = async (
  trancheId: number
): Promise<any> => {
  try {
    const response: AxiosResponse<ProjectModel[]> =
      await axiosInstance.get<any>("tranches/" + trancheId + "/visites/");
    return response.data;
  } catch (error: any) {
    console.error("Fetch visites by tranche failed", error);
    throw error.response?.data || "Fetch visites by tranche failed";
  }
};
